import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { UserListComponent } from './user-list/user-list.component';
import { UserDetailComponent } from './user-detail/user-detail.component';
import { UserAccountComponent } from './user-account/user-account/user-account.component';
import { UserConfirmComponent } from './user-confirm/user-confirm.component';
import { UserListService } from '../core/service/grid-data/grid-data-user.service';
import { UserOnlineComponent } from './user-online/user-online.component';
import { provideZxvbnServiceForPSM } from '@wise-community/angular-password-strength-meter/zxcvbn';
import { PasswordStrengthMeterComponent } from '@wise-community/angular-password-strength-meter';

@NgModule({
  imports: [
    SharedModule,
    PasswordStrengthMeterComponent
  ],
  declarations: [
    UserListComponent,
    UserDetailComponent,
    UserAccountComponent,
    UserConfirmComponent,
    UserOnlineComponent
  ],
  exports: [
    UserListComponent
  ],
  providers: [
    UserListService,
    provideZxvbnServiceForPSM()
  ]
})
export class UserModule { }
